export default class TariffSeance {
    SeanceId: string = '';
    SeanceValue: string = '';

    static SeanceTime(seance: TariffSeance): string | undefined {
        if (seance.SeanceValue != null && seance.SeanceValue != '')
            return seance.SeanceValue.split(' ', 1)[0];
    }
}